"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arc2 = void 0;
var react_1 = __importDefault(require("react"));
var Arc2 = function (_a) {
    var _b = _a.stroke, stroke = _b === void 0 ? "white" : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? "2" : _c, props = __rest(_a, ["stroke", "strokeWidth"]);
    return (react_1.default.createElement("path", __assign({ d: "M7.99998 10.4C7.5253 10.4 7.06128 10.2592 6.66661 9.9955C6.27193 9.73179 5.96431 9.35696 5.78266 8.91842C5.60101 8.47987 5.55349 7.99731 5.64609 7.53176C5.7387 7.0662 5.96727 6.63857 6.30292 6.30292C6.63857 5.96727 7.0662 5.7387 7.53176 5.64609C7.99731 5.55349 8.47987 5.60101 8.91842 5.78266C9.35696 5.96432 9.73179 6.27193 9.9955 6.66661C10.2592 7.06129 10.4 7.5253 10.4 7.99998", strokeWidth: strokeWidth, stroke: stroke }, props)));
};
exports.Arc2 = Arc2;
